import { api } from "../api";
import type {
  Center,
  CenterCreate,
  CenterWithManager,
  CenterUpdate,
  PaginatedResponse,
} from "../../types/domain";

export const centerService = {
  getAll: (params?: { skip?: number; limit?: number; include_manager?: boolean }) => {
    const query = new URLSearchParams();
    if (params?.skip !== undefined) query.set("skip", String(params.skip));
    if (params?.limit !== undefined) query.set("limit", String(params.limit));
    if (params?.include_manager !== undefined) query.set("include_manager", String(params.include_manager));
    const qs = query.toString();
    return api.get<PaginatedResponse<CenterWithManager>>(`/centers${qs ? `?${qs}` : ""}`);
  },

  getById: (id: string) => api.get<Center>(`/centers/${id}`),

  create: (data: CenterCreate) => api.post<Center>("/centers", data),

  update: (id: string, data: CenterUpdate) =>
    api.patch<Center>(`/centers/${id}`, data),

  delete: (id: string) => api.delete<void>(`/centers/${id}`),

  getMyCenter: () => api.get<Center>("/centers/me"),

  updateMyCenter: (data: CenterUpdate) =>
    api.patch<Center>("/centers/me", data),
};
